/** Starter list of currencies a store can be set to — easy to extend, not exhaustive. Each entry's precision is the number of decimal places its display/formatting should use (see lib/format.ts's money()/compactMoney()). */
export interface CurrencyOption {
  code: string;
  label: string;
  precision: 0 | 2 | 3;
}

export const SUPPORTED_CURRENCIES: CurrencyOption[] = [
  { code: "MMK", label: "Myanmar Kyat (MMK)", precision: 0 },
  { code: "USD", label: "US Dollar (USD)", precision: 2 },
  { code: "THB", label: "Thai Baht (THB)", precision: 2 },
  { code: "SGD", label: "Singapore Dollar (SGD)", precision: 2 },
];

export function currencyPrecisionFor(code: string): 0 | 2 | 3 {
  return SUPPORTED_CURRENCIES.find((c) => c.code === code)?.precision ?? 0;
}
